import * as core from '../../../../../../../core'
import * as stakeholderChangeChampion from '../stakeholder-change-champion'

export const RESOURCE = {
  payload: {
    description: 'Not Applicable',
    enumId: core.dms.models.Enum.Id.from({
      partialId: stakeholderChangeChampion.RESOURCE.payload.partialId,
    }),
    id: 'Not Applicable',
    name: 'Not Applicable',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
